export function CalculateToleranceFactor(toleranceSamples) {

    // Get the greatest Expected value - ToleranceMin - ratio    
    let greatest = 0
    var i;
    for (i = 0; i < toleranceSamples.length; i++) {
        let ratio = parseFloat(toleranceSamples[i].toleranceErrorMin) / parseFloat(toleranceSamples[i].expectedValue)
        if (ratio > greatest) {
            greatest = ratio
        }
    }

    // Get the greatest Expected value - ToleranceMax - ratio    
    var y
    for (y = 0; y < toleranceSamples.length; y++) {
        let ratio = parseFloat(toleranceSamples[y].toleranceErrorMax) / parseFloat(toleranceSamples[y].expectedValue)
        if (ratio > greatest) {
            greatest = ratio
        }
    }

    // Multiply * 2 , but stay below 100
    let z = 2
    do {
        greatest = greatest * 2
        if (greatest > 100) {
            return (z / 2)
        }
        z = z * 2
    } while (greatest < 100);
}

export function CalculateToleranceFactorForOrderDetail(metaData) {

    // Get the greatest Expected value - ToleranceMin - ratio    
    let greatest = 0

    let ratio = parseFloat(metaData.MassDensity.MinTolerance) / parseFloat(metaData.MassDensity.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    ratio = parseFloat(metaData.MassDensity.MaxTolerance) / parseFloat(metaData.MassDensity.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    ratio = parseFloat(metaData.Length.MinTolerance) / parseFloat(metaData.Length.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    ratio = parseFloat(metaData.Length.MaxTolerance) / parseFloat(metaData.Length.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    ratio = parseFloat(metaData.Width.MinTolerance) / parseFloat(metaData.Width.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    ratio = parseFloat(metaData.Width.MaxTolerance) / parseFloat(metaData.Width.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    ratio = parseFloat(metaData.Thickness.MinTolerance) / parseFloat(metaData.Thickness.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    ratio = parseFloat(metaData.Thickness.MaxTolerance) / parseFloat(metaData.Thickness.Value)
    if (ratio > greatest) {
        greatest = ratio
    }

    if (greatest === 0) {
        return 100;
    }

    if(greatest == 0) {
        return 100;
    }
    // Multiply * 2 , but stay below 100
    let z = 2
    do {
        greatest = greatest * 2
        if (greatest > 100) {
            return (z / 2)
        }
        z = z * 2
    } while (greatest < 100);
}

